define('lq/licquidRuntimeSpa',[
    'lq',
    'underscore',
    'drops/action/action',
    'lq/runtimePiping',
    'lq/actionLoader',
    'lq/navigatorSpa',
    'lq/style',
    'lq/windowSize',
    'lq/services/application/applicationServiceFactory',
    'lq/services/action/actionServiceFactory',
    'lq/validatorGateway',
    'lq/highlighter',
    'lq/javascript/polyfill'
], function (lq, _, Action, RuntimePiping, ActionLoader, NavigatorSpa, Style, windowSize, applicationServiceFactory, actionServiceFactory, validatorGateway, highlighter) {

    var inIframe = function () {
        return window !== window.parent;
    };

    var LicquidRuntimeSpa = function () {
        if (window.cordova) {
            document.addEventListener('deviceready', function () {
                if (window.universalLinks) {
                    window.universalLinks.subscribe(null, function (eventData) {
                        window.location = eventData.url;
                    });
                }
            }, false);
        }
    };

    LicquidRuntimeSpa.prototype.start = function (setup) {
        if (setup.application.embedded) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'LicquidLoaded'
            }), '*');
        }

        var self = this;
        windowSize.withOnChanged(function () {
            if (self.acion) self.action.resize();
        });
        
        Style.defaultStyles = setup.application.styles.defaultStyles;

        this.action = null;

        this.$app = setup.$el;
        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .appendTo(this.$app);
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);

        this.globalPiping = RuntimePiping.createRoot(setup.application, this.$app);
        this.globalPiping.navigator = NavigatorSpa.withLocalStorage(setup.action.id, this.globalPiping.url, this.openNewAction.bind(this));
        this.globalPiping.errorHandler.addListener(this.handleError.bind(this));

        this.globalServices = _.map(setup.application.services, function (service) {
            return applicationServiceFactory.createService(service);
        });
        _.forEach(this.globalServices, function (globalService) {
            globalService.initialize();
        });

        this.actionLoader = new ActionLoader(this.globalPiping.url);
        this.actionLoader.addListener(this.showAction.bind(this));

        this.globalPiping.busyIndicator.show();
        this.openNewAction(setup.action.id, setup.parameters.globals, setup.parameters.locals);
    };

    LicquidRuntimeSpa.prototype.showAction = function (setup, parameters, state) {
        var self = this;
        
        $.extend(this.globalPiping.application, setup.application);
        
        var action = new Action(setup.action.view, this.globalPiping.application.options);
        action.backgroundDrops = setup.action.backgroundDrops;
        action.allLayouts = setup.action.allLayouts;
        action.defaultLayout = setup.action.defaultLayout;
        action.services = _.map(setup.action.services, function (service) {
            return actionServiceFactory.createService(service, action);
        });
        action.piping = this.globalPiping.createChildPiping(setup.action, parameters, action, this.$wrapper, this.$view);
        action.globals = _.clone(parameters.globals);
        action.locals = _.clone(parameters.locals);
        
        // todo svb SPA viewport should only be set once (but what with "growable" actions?)
        action.createAndRenderDrops($('#viewport'));

        if (this.action) {
            validatorGateway.unregisterListener(this.action.instanceId);

            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_UNLOADING',
                action: this.action
            });

            this.action.unsubscribeEventHandlersRecursive();

            if (!state || !state.ignoreHistory) {
                var pageUrl = setup.friendlyName
                    ? setup.friendlyName
                    : 'LicquidAction/Get/' + setup.action.id;

                var currentUrl = self.globalPiping.url.prepare(lq.getTenantUrl(pageUrl), {
                    globals: JSON.stringify(parameters.globals),
                    parameters: JSON.stringify(parameters.locals)
                });

                window.history.pushState({
                        actionId: setup.action.id,
                        globals: parameters.globals,
                        locals: parameters.locals
                    },
                    "",
                    currentUrl);
            }
        } else {
            window.addEventListener('popstate', function (e) {
                // todo svb SPA what if we are still loading another action ?
                self.openNewAction(e.state.actionId, e.state.globals, e.state.locals, { ignoreHistory: true });
            });

            window.history.replaceState({
                actionId: setup.action.id,
                globals: parameters.globals,
                locals: parameters.locals
            }, '', window.location.href);
        }
        
        this.$wrapper.scrollTop(0);
        this.action = action;
        this.action.piping.busyIndicator.forceHide();

        validatorGateway.registerListener(action.instanceId, this.receiveMessage.bind(this));

        validatorGateway.publishEvent({
            type: 'ACTION_INSTANCE_LOADED',
            action: action
        });

        if (inIframe()) {
            window.parent.postMessage(JSON.stringify({
                eventName: 'EmbeddedActionLoaded',
                sizeX: action.data.size.x,
                sizeY: action.data.size.y
            }), window.location.protocol + '//' + window.location.host);
        }
    };

    LicquidRuntimeSpa.prototype.receiveMessage = function (message) {
        var self = this;

        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.openNewAction(this.action.data.id, this.action.globals, this.action.locals, { ignoreHistory: true });
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    LicquidRuntimeSpa.prototype.openNewAction = function (actionId, globals, locals, state) {
        this.actionLoader.load(actionId, globals, locals, state);
    };

    LicquidRuntimeSpa.prototype.handleError = function (errorArgs) {
        if (this.action) this.action.error(errorArgs);
    };
    
    return LicquidRuntimeSpa;
});
